/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ReactElement } from 'react';
import { PageData, PageType } from 'its-pages';

export abstract class PageContent {
  private _pageData: PageData;

  public get pageData(): PageData {
    return this._pageData;
  }
  public abstract get component(): ReactElement;
  public abstract get pageType(): PageType;

  protected constructor(pageData: PageData) {
    this._pageData = pageData;
  }
}
